export class BidPrequalification {
    id!: string
    name!: string
    bidTypeId!: string
    bidRangeId!: string
    estimatorHrRef!: number
    schedulerHrRef!: number
    pmHrRef!: number
    superHrRef!: number
    dueDate?: Date
    notificationDate?: Date
    docsAvailableDate?: Date
    completionDate?: Date
    prequalMeeting!: boolean
    preProposalMeetingDate?: Date
    mandatory!: boolean
    complete!: boolean
    notes!: string

    // TODO: If we remove JsonDateInterceptor, we can deserialize the dates here.
    // protected $deserialize(source: any): void {
    //     this.dueDate = source.dueDate ? new Date(source.dueDate) : undefined
    //     this.notificationDate = source.notificationDate ? new Date(source.notificationDate) : undefined
    //     this.docsAvailableDate = source.docsAvailableDate ? new Date(source.docsAvailableDate) : undefined
    //     this.completionDate = source.completionDate ? new Date(source.completionDate) : undefined
    //     this.preProposalMeetingDate = source.preProposalMeetingDate ? new Date(source.preProposalMeetingDate) : undefined
    // }
}
